import axios from "fetch-api/fetch-api";
import { getVehicleWithFitmentOptions } from "../../util/vehicle/get-vehicle-with-fitment-options";
import { IActionResponse } from "../interfaces/base-response";

// vehicle = { make, model, year, engine } (optional)

export function addItemApi(
  sku: string,
  vehicle = undefined,
  quantity = 1,
  customOptions?: {
    customTireSizes?: string[],
    customWheelSizes?: string[],
  },
) {
  const fitmentVehicle = vehicle ? getVehicleWithFitmentOptions(vehicle) : undefined;

  const payload = {
    sku,
    quantity,
    vehicle: fitmentVehicle,
    ...Object.fromEntries(
      Object.entries(customOptions || {}).filter(
        ([_, value]) => Array.isArray(value) && value.length,
      ),
    ),
  };

  return axios.post<IActionResponse>("/add-to-cart-by-sku-v3", payload);
}
